<template>
    <div data-testid="riskmanagement_home__root">
      <div class="all-height d-flex justify-center" data-testid="riskmanagement_home__main-panel">
        <div class="all-width" data-testid="riskmanagement_home__content-panel">
          <v-card
            :loading="loading"
            :disabled="loading"
            loader-height="2"
            class=""
            data-testid="riskmanagement_home__card"
          >
            <v-card-text class="pb-0" data-testid="riskmanagement_home__toolbar-panel">
              <div class="d-flex align-center" data-testid="riskmanagement_home__toolbar">
                <v-btn
                  @click="add()"
                  rounded
                  color="primary"
                  elevation="0"
                  class="mr-2"
                  data-testid="riskmanagement_home__add-bot-btn"
                  ><v-icon class="mr-1">mdi-plus</v-icon><span>Add bot</span></v-btn
                >
                <lb-string
                  label="Search"
                  outlined
                  hidedetails
                  v-model="search"
                  data-testid="riskmanagement_home__search-input"
                ></lb-string>
                <v-spacer></v-spacer>
                <v-chip label class="border-left-error" outlined data-testid="riskmanagement_home__disabled-chip"
                  ><span>Disabled</span></v-chip
                >
                <v-btn @click="getData()" icon class="ml-2" data-testid="riskmanagement_home__refresh-btn"
                  ><v-icon>mdi-refresh</v-icon></v-btn
                >
              </div>
            </v-card-text>
            <v-card-text data-testid="riskmanagement_home__table-panel">
              <v-data-table
                class="cursor-pointer Pl-table"
                @click:row="openDetails"
                :headers="headers"
                dense
                :search="search"
                :items="getName"
                :items-per-page="-1"
                hide-default-footer
                data-testid="riskmanagement_home__table"
              >
                <template #[`item.botid`]="{ item }">
                  <span
                    style="text-decoration: none"
                    data-testid="riskmanagement_home__table-botname"
                    >{{ item.botname }}</span
                  >
                </template>
                <template #[`item.from`]="{ value }">
                  <span data-testid="riskmanagement_home__table-from">{{ $nova.formatDate(value) }}</span>
                </template>
                <template #[`item.to`]="{ value }">
                  <span data-testid="riskmanagement_home__table-to">{{ $nova.formatDate(value) }}</span>
                </template>
                <template v-slot:[`item.stage`]="{ value }">
                  <v-chip label color="success" v-if="value === 2" data-testid="riskmanagement_home__table-stage-closed"
                    ><span>Closed</span></v-chip
                  >
                  <v-chip label text color="warning" v-if="value === 1" data-testid="riskmanagement_home__table-stage-review"
                    ><span>Review</span></v-chip
                  >
                  <v-chip label text color="info" v-if="value === 0" data-testid="riskmanagement_home__table-stage-open"
                    ><span>Open</span></v-chip
                  >
                </template>
                <template #[`item.actions`]="{ item }">
                  <div class="" data-testid="riskmanagement_home__table-actions">
                    <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon @click.stop="editBot(item)" data-testid="riskmanagement_home__table-edit-btn">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <v-dialog v-model="createpopup" max-width="600" persistent data-testid="riskmanagement_home__dialog">
            <v-card data-testid="riskmanagement_home__dialog-card">
              <v-card-text
                class="tableHeaderBg d-flex align-center py-2 px-4"
                data-testid="riskmanagement_home__dialog-header"
              >
                <span class="font-size-md" v-if="!editId" data-testid="riskmanagement_home__dialog-title-create"
                  >Create Projects</span
                >
                <span class="font-size-md" v-else data-testid="riskmanagement_home__dialog-title-update">Update Projects</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="createpopup = false" class="ml-2" data-testid="riskmanagement_home__dialog-close-btn"
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </v-card-text>
              <v-card-text class="mt-4 pt-4" data-testid="riskmanagement_home__dialog-content">
                <v-row>
                  <v-col cols="12" class="my-0 py-1">
                    <lb-dropdown
                      label="Select Bots"
                      v-model="allbots"
                      :items="getBots"
                      itemtext="name"
                      itemvalue="_id"
                      data-testid="riskmanagement_home__dialog-bots-dropdown"
                    />
                  </v-col>
                  <v-col cols="6" class="my-0 py-1">
                    <lb-date
                      v-model="dateOne"
                      label="From"
                      :max="$nova.formatDateISO(new Date())"
                      data-testid="riskmanagement_home__dialog-date-from"
                    />
                  </v-col>
                  <v-col cols="6" class="my-0 py-1">
                    <lb-date
                      v-model="dateTwo"
                      label="To "
                      :min="dateOne"
                      data-testid="riskmanagement_home__dialog-date-to"
                    />
                  </v-col>
                </v-row>
                <v-card-text class="d-flex" data-testid="riskmanagement_home__dialog-actions-panel">
                  <v-spacer></v-spacer>
                  <v-btn @click="update()" v-if="editId" color="primary" data-testid="riskmanagement_home__dialog-update-btn"
                    ><span>Update</span></v-btn
                  >
                  <v-btn @click="createBot()" v-else color="primary" data-testid="riskmanagement_home__dialog-save-btn"><span>Save</span></v-btn>
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </template>
  <script>
  // import CallLog from "../../../components/CallLog.vue";
  export default {
    
    data() {
      return {
        editId: null,
        dateOne: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString(),
        dateTwo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString(),
        allbots: "",
        name: "",
        getBots: [],
        search: "",
        getName: [],
        projectId: "",
        createpopup: false,
        loading: false,
        headers: [
          { text: "Name", value: "botid" },
          { text: "From", value: "from" },
          { text: "To", value: "to" },
          { text: "Actions", value: "actions" },
          { text: "Status", value: "stage" },
        ],
      };
    },
    components:{
      // CallLog,
    },
    created() {
      this.refreshData();
      this.getData();
    },
    activated(){
        this.refreshData();
    },
    methods: {
      refreshData(){
            this.projectId = this.$route.params.id || "";
      },
      getData() {
        this.loading = true;
        const payload = { project: this.projectId };
        
        this.axios
          .post("/v2/bot/project/get/", payload)
          .then((ele) => {
            if (ele.data.status === "success") {
              this.getName = ele.data.data;
              
              this.axios
                .post("v2/conserve/bot/get")
                .then((ele) => {
                  this.getBots = ele.data.data;
                })
                .catch((err) => {
                  console.log("Error fetching bots",err);
                });
            }
          })
          .catch((err) => {
            console.log("Error fetching filtered bot project",err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      createBot() {
        this.loading = true;
        let obj = {
          botid: this.allbots,
          from: this.dateOne,
          to: this.dateTwo,
          project: this.projectId,
        };
        this.axios
          .post("/v2/bot/project/add", { pid: this.projectId, data: obj })
          .then((ele) => {
            if (ele.data.status === "success") {
              this.$store.commit("sbSuccess", "added successfully");
              this.getData();
              this.createpopup = false;
            }else {
              throw new Error("Error adding Bot")
            }          
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      add() {
        this.createpopup = true;
        this.allbots = "";
        this.dateOne = "";
        this.dateTwo = "";
        this.editId = null;
      },
      editBot(item) {
        this.editId = item._id;
        this.allbots = item.botid;
        this.dateOne = item.from;
        this.dateTwo = item.to;
        this.createpopup = true;
      },
      update() {
        this.loading = true;
        this.createpopup = false;
        let data = { from: this.dateOne, to: this.dateTwo, botid: this.allbots };
        this.axios
          .post("/v2/bot/project/edit/" + this.editId, { data })
          .then((ele) => {
            if (ele.data.status === "success") {
              this.$store.commit("sbSuccess", "updated successfully");
              this.getData();
            } else {
              throw new Error("Error updating Bots");
            }
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      openDetails(item) {
        this.$nova.gotoLink({path: "/financialclose/automation/riskmanagementbotview/" + item._id});
      },
    },
  };
  </script>
